import React from 'react';
import { textboxFrameStyle } from '../constants/authStyles';

/**
 * Arka planda çerçeve görseli; üzerinde tamamen şeffaf input — sadece yazı görünür.
 */
export default function AuthTextField({
  id,
  name,
  type = 'text',
  value,
  onChange,
  required,
  placeholder,
  minLength,
  autoComplete
}) {
  return (
    <div className="auth-input-wrap">
      <span className="auth-input-frame" style={textboxFrameStyle} aria-hidden="true" />
      <input
        id={id}
        name={name}
        type={type}
        className="auth-input"
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        minLength={minLength}
        autoComplete={autoComplete}
      />
    </div>
  );
}
